export const HOST = process.env.REACT_APP_API_URL;
export const ZOMATO_HOST = process.env.REACT_APP_ZOMATO_DOMAIN;
export const ENTERPRISE_HOST = process.env.REACT_APP_ENTERPRISE_DOMAIN;
export const HOME_PAGE = '/';
export const BASE_URL = `${HOST}/gw/corporate_ordering`;
export const ZPAYKT_BASE_URL = `${ZOMATO_HOST}/zpaykit`;
export const GET_PAYMENT_CODE = `${BASE_URL}/payment/zpaykitCode`;
export const REDIRECT_URL_ONLINE_PAYMENT = `${ENTERPRISE_HOST}/dashboard/#/payments/status`;
export const REDIRECT_URL_LOGEED_OUT_ONLINE_PAYMENT = `${ENTERPRISE_HOST}/payment/status`;
export const GET_AUTH_VALIDATE = `${HOST}/gw/auth/validate`;
export const SET_SPOC_INVITE = `${BASE_URL}/invitation/accept`;
export const GET_SPOC_VALIDATE = `${BASE_URL}/invitation/validate`;
export const GET_AUTH_CHECK = `${BASE_URL}/auth`;
export const COMPANY_PROFILE = `${BASE_URL}/company/profile`;
export const COMPANY_VERIFY = `${BASE_URL}/company/verify`;
export const CREATE_PROGRAM_URL = `${BASE_URL}/program/confirm_creation`;
export const REVIEW_PROGRAM_URL = `${BASE_URL}/program/save_draft`;
export const REVIEW_PROG_TO_EMP_URL = `${BASE_URL}/program/employee_mapping/review`;
export const GET_EMPLOYEES_FOR_PROGRAM = `${BASE_URL}/program/employees`;
export const GET_PAYMENTS_FOR_PROGRAM = `${BASE_URL}/program/payments`;
export const GET_CREDIT_TRANSACTIONS_FOR_PROGRAM = `${BASE_URL}/program/credit_transactions`;
export const GET_COMPANY_OFFICES = `${BASE_URL}/company/offices`;
export const CREATE_GROUP_URL = `${BASE_URL}/group/create`;
export const CONFIRM_GROUP_URL = `${BASE_URL}/program/add_employee/review`;
export const SET_ADD_EMPLOYEE_TOPUP_CYCLE_URL = `${BASE_URL}/program/add_employee/topup_cycle`;
export const UPLOAD_GROUP_URL = `${BASE_URL}/group/upload`;
export const UPLOAD_EMPLOYEES_URL = `${BASE_URL}/employee/upload`;
export const GET_ALL_GROUPS = `${BASE_URL}/group/all`;
export const GET_ALL_PROGRAMS = `${BASE_URL}/program/all`;
export const GET_TOP_PROGRAMS = `${BASE_URL}/program/top`;
export const GET_EMPLOYEE_SECTION = `${BASE_URL}/employee/section`;
export const GET_ALL_EMPLOYEES = `${BASE_URL}/employee/all`;
export const REMOVE_EMPLOYEE_FROM_COMPANY = `${BASE_URL}/employee/remove`;
export const UPSERT_EMPLOYEE_URL = `${BASE_URL}/employee/upsert`;
export const GET_EMPLOYEE_DETAILS = `${BASE_URL}/employee/details`;
export const GET_EMPLOYEE_CREDIT_TRANSACTIONS = `${BASE_URL}/employee/credit_transactions`;
export const TOGGLE_EMPLOYEE_STATUS = `${BASE_URL}/employee/activate`;
export const GET_PROGRAM_INFO = `${BASE_URL}/program/info`;
export const GET_PROGRAM_DETAILS = `${BASE_URL}/program/details`;
export const GET_GROUP_DETAILS = `${BASE_URL}/group/details`;
export const GET_EMPLOYEES_FOR_GROUP = `${BASE_URL}/group/employees`;
export const TOGGLE_PROGRAM_STATUS = `${BASE_URL}/program/activate`;
export const GET_ALL_PAYMENTS = `${BASE_URL}/payment/all`;
export const GET_PAYMENT_DEBITS = `${BASE_URL}/events/fundsblocked`;
export const UPSERT_PAYMENT_URL = `${BASE_URL}/payment/create`;
export const GET_ONLINE_PAYMENT_INFO = `${BASE_URL}/online-payment/info`;
export const CHECKOUT_DETAILS = `${BASE_URL}/online-payment/checkout_details`;
export const GET_ALL_POI = `${BASE_URL}/company/poi/all`;
export const LANDING_PAGE = `${BASE_URL}/landing_page`;
export const GET_UPCOMING_TOPUPS = `${BASE_URL}/events/upcoming`;
export const GET_PREVIOUS_TOPUPS = `${BASE_URL}/events/previous`;
export const GET_EVENT_DETAILS = `${BASE_URL}/events/credit-transactions`;
export const REVIEW_ADD_PROGRAM_TO_GROUP = `${BASE_URL}/program/add_group/review`;
export const ADD_PROGRAM_TO_GROUP = `${BASE_URL}/program/add_group/add`;
export const MAKE_PAYMENT_CDNG = `${ZOMATO_HOST}/webroutes/cdng/makePayment`;
export const GET_CONSUMPTION_DETAILS = `${BASE_URL}/orders/all`;
export const GET_ORDERS_INSIGHTS = `${BASE_URL}/company/insights/orders`;
export const GET_ORDER = `${BASE_URL}/company/order`;
export const GET_ORDER_INVOICE = `${BASE_URL}/order/invoice`;
export const GET_EMPLOYEE_CONSUMPTIONS = `${BASE_URL}/employee/orders`;
export const GET_COMPANY_INVOICES = `${BASE_URL}/invoice/all`;
export const GET_INVOICE_DETAILS = `${BASE_URL}/invoice/details`;
export const GET_PAYMENTS_FOR_INVOICE = `${BASE_URL}/invoice/payments`;
export const GET_INVOICE_FILES = `${BASE_URL}/invoice/files`;
export const GET_ALL_QUESTIONS = `${BASE_URL}/question/all`;
export const REVIEW_PROGRAM_EMPLOYEE_MAPPING = `${BASE_URL}/program/employee_mapping/review`;
export const GET_PAYMENT_REQUEST_LOG = `${BASE_URL}/payment/request`;
export const GET_PAYMENT_INFO = `${BASE_URL}/payment/info`;
export const GET_ALL_REPORTS = `${BASE_URL}/report/all`;
export const GET_REPORT_DETAILS = `${BASE_URL}/report/details`;
export const GENERATE_REPORT = `${BASE_URL}/report/generate`;
export const GET_ALL_GIFT_CARD = `${BASE_URL}/giftcard/all`;
export const UPDATE_PAYMENT_MODES = `${BASE_URL}/program/payment_modes/update`;
export const ORDER_EXPENSE_REQUEST_ACTION = `${BASE_URL}/order_expense/action`;
export const EXPENSE_REQUEST_ACTION = `${BASE_URL}/expense/action`;
export const INSERT_LEADS = `${BASE_URL}/lead_generation/submit`;
export const GET_GIFT_CARD_DETAILS = `${BASE_URL}/giftcard`;
export const CREATE_GIFT_CARD = `${BASE_URL}/giftcard/create`;
export const UPDATE_PROGRAM_STATUS = `${BASE_URL}/program/activate`;
